export const numeroATexto = (n) => {
    const unidades = ["", "uno", "dos", "tres", "cuatro", "cinco", "seis", "siete", "ocho", "nueve"];
    const decenas = ["", "", "veinte", "treinta", "cuarenta", "cincuenta", "sesenta", "setenta", "ochenta", "noventa"];
    const especiales = ["diez", "once", "doce", "trece", "catorce", "quince", "dieciséis", "diecisiete", "dieciocho", "diecinueve"];

    function convertir(num) {
        if (num < 10) return unidades[num];
        if (num < 20) return especiales[num - 10];
        if (num < 100) return (
            decenas[Math.floor(num / 10)] +
            (num % 10 !== 0 ? " y " + unidades[num % 10] : "")
        );
        if (num < 1000) {
            if (num === 100) return "cien";
            return (
                (num < 200 ? "ciento" : unidades[Math.floor(num / 100)] + "cientos") +
                (num % 100 !== 0 ? " " + convertir(num % 100) : "")
            );
        }
        if (num < 1000000) {
            const miles = Math.floor(num / 1000);
            const resto = num % 1000;
            return (
                (miles === 1 ? "mil" : convertir(miles) + " mil") +
                (resto > 0 ? " " + convertir(resto) : "")
            );
        }
        if (num < 1000000000) {
            const millones = Math.floor(num / 1000000);
            const resto = num % 1000000;
            return (
                (millones === 1 ? "un millón" : convertir(millones) + " millones") +
                (resto > 0 ? " " + convertir(resto) : "")
            );
        }
        return "Número demasiado grande";
    }

    const partes = n.toFixed(2).split(".");
    const entero = parseInt(partes[0]);
    const centavos = parseInt(partes[1]);

    const textoEntero = convertir(entero);
    return centavos > 0
        ? `${textoEntero} con ${centavos.toString().padStart(2, "0")}/100`
        : textoEntero;
}

export const aNumero = (valor) => (valor ? Number(valor) : 0);